import React from 'react';
import { Link } from 'react-router';
import config from "../../../config";

class LostKeyComboCallouts extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e) {
		global.dataLayer.push({
			event: 'Lost Key Combo',
			eventCategory: 'Support',
			eventAction: e.currentTarget.textContent,
			eventLabel: global.location.pathname
		});
	}

	render() {
		const currentUrl = "/support/lost-key-combo";
		const replacementURl = "https://replacements.masterlock.com/";
		let euUkStoreLink = `${config.euUkReplacementUrl}`;
		let canadaStoreLink = `${config.canadaStoreLink}`;
		return (
			<div className="lost-key-combo">
				<div className="replacement-process-callouts">
					<div className="row">
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={replacementURl}
								target={'_blank'}
								onClick={e => this.handleClick(e)}
							>
								<div>
									<img
										src={require('../../../resources/img/icons/key-icon.png')}
										srcSet={`${require('../../../resources/img/icons/key-icon@2x.png')} 2x`}
										alt="Key"
									/>
									<img
										src={require('../../../resources/img/icons/combo-icon.png')}
										srcSet={`${require('../../../resources/img/icons/combo-icon@2x.png')} 2x`}
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process <br /> US
								</p>
							</Link>
						</div>
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={canadaStoreLink}
								onClick={e => this.handleClick(e)}
								target={'_blank'}
							>
								<div>
									<img
										src={require('../../../resources/img/icons/key-icon.png')}
										srcSet={`${require('../../../resources/img/icons/key-icon@2x.png')} 2x`}
										alt="Key"
									/>
									<img
										src={require('../../../resources/img/icons/combo-icon.png')}
										srcSet={`${require('../../../resources/img/icons/combo-icon@2x.png')} 2x`}
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process <br /> Canada
								</p>
							</Link>
						</div>
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={euUkStoreLink}
								onClick={e => this.handleClick(e)}
								target={'_blank'}
							>
								<div>
									<img
										src={require('../../../resources/img/icons/key-icon.png')}
										srcSet={`${require('../../../resources/img/icons/key-icon@2x.png')} 2x`}
										alt="Key"
									/>
									<img
										src={require('../../../resources/img/icons/combo-icon.png')}
										srcSet={`${require('../../../resources/img/icons/combo-icon@2x.png')} 2x`}
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process <br /> UK/EU
								</p>
							</Link>
						</div>

					</div>
				</div>
			</div>
		);
	}
};

export default LostKeyComboCallouts;


// WEBPACK FOOTER //
// ./src/pages/support/lostKeyCombo/LostKeyComboCallouts.js